module.exports = __webpack_public_path__ + "static/img/2020@2x.dd5034d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2020@2x.png
// module id = u134
// module chunks = 1